import { Navigate, useParams } from 'react-router-dom';

export function QuotationEditPage() {
  const { quotationId } = useParams();
  return <Navigate to={`/quotations/${quotationId}?edit=true`} replace />;
}

export default QuotationEditPage;
